export function themeLabel(theme: 'light' | 'dark') {
  switch (theme) {
    case 'dark':
      return 'Mörkt tema';
    case 'light':
      return 'Ljust tema';
  }
}
